<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <div class="comp-ly-attachment-list" :class="props?.all ? 'attachment-list-all' : ''" v-if="fileList?.length">
    <div class="attachments-list" v-if="props.all">
      <span class="attach-item" v-for="(item, index) of fileList" :key="item?.url">
        <fh-attachment-preview :file-item="item" :show-video-cover="true" :icon-style="iconStyle20" :showName="false" :index="index" :list="fileList" />
      </span>
    </div>
    <template v-else>
      <jw-overflow-list>
        <span class="hand attach-item" v-for="(item, index) of fileList" :key="item?.url">
          <fh-attachment-preview :file-item="item" :show-video-cover="true" :icon-style="iconStyle24" :showName="false" :index="index" :list="fileList" />
        </span>
        <template #overflow="{ number }">
          <jw-tag size="small">+{{ number }}</jw-tag>
        </template>
      </jw-overflow-list>
    </template>
  </div>
  <span v-else>-</span>
</template>

<script setup>
import { computed } from 'vue';
import { tools } from '@/utils/tools.js';
const props = defineProps({
  fieldValue: {
    type: String || Array,
    default: '[]'
  },
  all: {
    type: Boolean,
    default: false
  }
});
const iconStyle20 = {
  width: '20px',
  height: '20px'
};
const iconStyle24 = {
  width: '24px',
  height: '24px'
};
const defaultFileList = computed(() => (tools.isJSON(props.fieldValue) ? JSON.parse(props.fieldValue) : Array.isArray(props.fieldValue) && props.fieldValue?.length > 0 ? props.fieldValue : []));
const fileList = computed(() => {
  const fieldValue = defaultFileList.value;
  return Array.isArray(fieldValue) ? fieldValue.filter((item) => item != null) : [];
});
</script>
<style scoped lang="less">
@import './ly-attachment-list.less';
</style>
